// extracted by mini-css-extract-plugin
export default {"mortageModel":"index_mortageModel__DAtPT"};